import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Outcome, OutcomeRequestApi, OutcomeService } from 'src/app/services/outcome.service';

@Component({
  selector: 'app-outcome',
  templateUrl: './outcome.component.html',
  styleUrls: ['./outcome.component.scss']
})
export class OutcomeComponent implements OnInit {

  @Input('showdate') showdate: boolean = false;
  @Input('showdata') showdata: boolean = true;
  @Input('ocdata') ocdata: Outcome = null; 
  @Input('reqdata') reqdata: OutcomeRequestApi[]  = null; 
  @ViewChild('reqcontent', { static: true }) reqcontent: any;

  constructor(
    private modalService: NgbModal,
    private outcomeService: OutcomeService,
  ) { }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-notes'});
  }

  saveRequestUpdate($event) {
    this.outcomeService.changeOCRequestEvent($event);
    if (!!$event) {
      this.outcomeService.changeOCRequestEvent(null);
      if ($event.target.innerText === 'Ok') {
        this.modalService.dismissAll();
      }
    }
  }
}
